import axios from 'axios';

const PolicyFilePathService = {
  async fetch() {
    return axios.get('/order/api/policy');
  }
};

export default PolicyFilePathService;